export default __webpack_public_path__ + "static/media/auteuil13.9aae8145.jpg";